import { Button } from '../../../cdl/Button/Button';
import { translate } from '../../../common/helpers/translate.helper';
import { IconInfoCircle } from '../../../common/icons/cdl/InfoCircle';
import { StatusBar } from '../../../common/StatusBar/StatusBar';
import { StatusBarType } from '../../../common/StatusBar/StatusBarType';
import { Box } from '../../../common/ui/Box';

import { useCompareSelectionState } from './hooks/useCompareSelectionState';
import { OverlayPriceInfoSection } from './OverlayPriceInfoSection';
import { useRole } from '../../../common/hooks/useRole.ts';
import { OverlayHeader } from '../../../common/Overlay/OverlayHeader';
import { ButtonGroup } from '../../../common/buttons/ButtonGroup';

export const CompareOverlay = ({
    items,
    portIds,
    customerId,
    vesselId,
    defaultContractId,
    schedules,
    onClose,
    onApply,
    deliveryDate,
}) => {
    const { selection } = useCompareSelectionState();

    const role = useRole();

    return (
        <Box paddingBottom={64} minHeight="100%" backgroundColor="#F6F7F7">
            <OverlayHeader
                title={translate('compare.title')}
                trailingVisual={
                    <ButtonGroup>
                        <Button onClick={onClose} type="button">
                            {role.isSuperAdmin() ? translate('btn.goBack') : translate('actions.cancel')}
                        </Button>

                        {!role.isSuperAdmin() ? (
                            <Button
                                emphasis="high"
                                type="button"
                                onClick={onApply}
                                disabled={!selection.portId || !selection.supplierIds.length}
                            >
                                {translate('actions.applyselection')}
                            </Button>
                        ) : null}
                    </ButtonGroup>
                }
            >
                <Box paddingX={24} maxWidth="1420px" marginX="auto">
                    <Box paddingX={24}>
                        <Box paddingTop={24}>
                            <StatusBar
                                headline={translate('compare.overlay.bar.headline')}
                                subHeadline={translate('compare.overlay.bar.description')}
                                type={StatusBarType.WHITE}
                                icon={<IconInfoCircle />}
                            />
                        </Box>

                        <OverlayPriceInfoSection
                            items={items}
                            portIds={portIds}
                            customerId={customerId}
                            vesselId={vesselId}
                            defaultContractId={defaultContractId}
                            schedules={schedules}
                            deliveryDate={deliveryDate}
                        />

                        {!role.isSuperAdmin() ? (
                            <Box display="flex" justifyContent="center" marginTop={64}>
                                <Box marginRight={8}>
                                    <Button onClick={onClose} type="button">
                                        {translate('actions.cancel')}
                                    </Button>
                                </Box>

                                <Button
                                    emphasis="high"
                                    type="button"
                                    onClick={onApply}
                                    disabled={!selection.portId || !selection.supplierIds.length}
                                >
                                    {translate('actions.applyselection')}
                                </Button>
                            </Box>
                        ) : null}
                    </Box>
                </Box>
            </OverlayHeader>
        </Box>
    );
};
